export const buildPaginationPages = ({
    currentPage,
    totalPages,
    maxVisiblePages = 5,
    showEdges = true,
    withEllipsis = true,
  }) => {
    if (!totalPages || totalPages <= 0) {
      return [];
    }
  
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, idx) => idx + 1);
    }
  
    const half = Math.floor(maxVisiblePages / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, start + maxVisiblePages - 1);
  
    if (end - start + 1 < maxVisiblePages) {
      start = Math.max(1, end - maxVisiblePages + 1);
    }
  
    const pages = [];
  
    if (showEdges && start > 1) {
      pages.push(1);
      if (withEllipsis && start > 2) {
        pages.push('...');
      }
    }
  
    for (let page = start; page <= end; page++) {
      pages.push(page);
    }
  
    if (showEdges && end < totalPages) {
      if (withEllipsis && end < totalPages - 1) {
        pages.push('...');
      }
      pages.push(totalPages);
    }
  
    return pages;
  };
  
  